import {apiAction} from './api'
import {
  CREATE_PAYMENT_METHOD,
  CURRENT_SUBSCRIPTION,
  DELETE_PAYMENT_METHOD,
  GET_BILLING_ADDRESS,
  GET_DESK_PLANS,
  GET_PAYMENT_METHOD,
  UPDATE_BILLING_ADDRESS,
  UPDATE_PAYMENT_METHOD,
  START_BILLING,
  UPDATE_BILLING,
  CANCEL_BILLING,
  RESUME_BILLING,
  CALCULATE_BILLING,
  REFRESH_ACCESS_TOKEN,
} from './types'
import {USER_ACCOUNTS} from './endpoint'

export function currentSubscription() {
  return apiAction({
    url: `${USER_ACCOUNTS}/billing/currentsubscription`,
    method: 'GET',
    label: CURRENT_SUBSCRIPTION,
  })
}

export function getPaymentMethods() {
  return apiAction({
    url: `${USER_ACCOUNTS}/billing/paymentmethods`,
    method: 'GET',
    label: GET_PAYMENT_METHOD,
  })
}

export function createPaymentMethods(data) {
  return apiAction({
    url: `${USER_ACCOUNTS}/billing/paymentmethods`,
    method: 'POST',
    label: CREATE_PAYMENT_METHOD,
    data,
    successMessage: 'Card Added',
    showToast: true,
  })
}

export function createPaymentMethodsToken(token) {
  return apiAction({
    url: `${USER_ACCOUNTS}/billing/card/token`,
    method: 'POST',
    label: CREATE_PAYMENT_METHOD,
    data: token,
    showToast: true,
    successMessage: 'Card Added',
  })
}

export function updatePaymentMethods(id, data) {
  return apiAction({
    url: `${USER_ACCOUNTS}/billing/paymentmethods/${id}/default`,
    method: 'PUT',
    label: UPDATE_PAYMENT_METHOD,
    data,
    successMessage: 'Default Card Updated',
    showToast: true,
  })
}

export function deletePaymentMethods(id, data) {
  return apiAction({
    url: `${USER_ACCOUNTS}/billing/paymentmethods/${id}`,
    method: 'DELETE',
    label: DELETE_PAYMENT_METHOD,
    data,
    successMessage: 'Card Deleted',
    showToast: true,
  })
}

export function updateBillingAddress(data) {
  return apiAction({
    url: `${USER_ACCOUNTS}/billing/address`,
    method: 'POST',
    label: UPDATE_BILLING_ADDRESS,
    data,
    successMessage: 'Billing Address Updated',
    showToast: true,
  })
}

export function getBillingAddress(data) {
  return apiAction({
    url: `${USER_ACCOUNTS}/billing/address`,
    method: 'GET',
    label: GET_BILLING_ADDRESS,
    data,
  })
}

export function getDeskPlans(data) {
  return apiAction({
    url: `${USER_ACCOUNTS}/plans`,
    method: 'GET',
    label: GET_DESK_PLANS,
    data,
  })
}

export function startBilling(data) {
  return apiAction({
    url: `${USER_ACCOUNTS}/billing/start`,
    method: 'POST',
    label: START_BILLING,
    data,
    successMessage: 'Subscription Started',
    showToast: true,
  })
}

export function updateBilling(data) {
  return apiAction({
    url: `${USER_ACCOUNTS}/billing/change`,
    method: 'POST',
    label: UPDATE_BILLING,
    data,
    successMessage: 'Subscription Updated',
    showToast: true,
  })
}

export function cancelBilling(data) {
  return apiAction({
    url: `${USER_ACCOUNTS}/billing/cancel`,
    method: 'POST',
    label: CANCEL_BILLING,
    data,
    successMessage: 'Subscription Cancelled',
    showToast: true,
  })
}

export function resumeBilling(data) {
  return apiAction({
    url: `${USER_ACCOUNTS}/billing/resumecancelled`,
    method: 'POST',
    label: RESUME_BILLING,
    data,
    successMessage: 'Subscription Resumed',
    showToast: true,
  })
}

export function calculateBilling(data) {
  return apiAction({
    url: `${USER_ACCOUNTS}/billing/calculateamount`,
    method: 'POST',
    label: CALCULATE_BILLING,
    data,
    // showToast: true,
  })
}

export function refreshAccessToken() {
  return apiAction({
    url: `${USER_ACCOUNTS}/refreshaccesstoken`,
    method: 'GET',
    label: REFRESH_ACCESS_TOKEN,
  })
}

// export function downloadInvoice(id) {
//   return Axios.request({
//     method: 'GET',
//     url: `${USER_ACCOUNTS}/billing/invoices/download/${id}`,
//     headers: {
//       Authorization: `Bearer ${getAppToken()}`,
//     },
//   })
//     .then(data => {
//       const blob = new Blob([data], {type: 'application/pdf'})
//       const link = document.createElement('a')
//       link.href = window.URL.createObjectURL(blob)
//       link.download = 'invoice.pdf'
//       link.click()
//     })
//     .catch(err => {
//       console.log({})
//     })
// }
